import { render, staticRenderFns } from "./FontAwesome.vue?vue&type=template&id=59b19de4&"
import script from "./FontAwesome.vue?vue&type=script&lang=js&"
export * from "./FontAwesome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports